"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Header_1 = __importDefault(require("./Header"));
var PlaySummary_1 = __importDefault(require("./PlaySummary"));
var Scene_1 = __importDefault(require("./Scene"));
var Waiting = function () {
    return React.createElement("div", null, "Loading...");
};
var LoadedPlay = function (props) {
    var params = (0, react_router_dom_1.useParams)();
    var curr_act_num = parseInt(params.act, 10);
    var curr_scene_num = parseInt(params.scene, 10);
    // console.log(`LoadedPlay() ${curr_act_num}/${curr_scene_num}`);
    if (!Number.isFinite(curr_act_num) || !Number.isFinite(curr_scene_num)) {
        throw new Error("invalid act ".concat(curr_act_num, " or scene ").concat(curr_scene_num, " number"));
    }
    var curr_act = props.play.acts[curr_act_num - 1];
    var curr_scene = curr_act.scenes[curr_scene_num - 1];
    var prev_scene = null;
    var next_scene = null;
    if (curr_scene_num > 1) {
        prev_scene = [curr_act_num, curr_scene_num - 1];
    }
    else if (curr_act_num > 1) {
        prev_scene = [
            curr_act_num - 1,
            props.play.acts[curr_act_num - 2].scenes.length,
        ];
    }
    if (curr_scene_num < curr_act.scenes.length) {
        next_scene = [curr_act_num, curr_scene_num + 1];
    }
    else if (curr_act_num < props.play.acts.length) {
        next_scene = [curr_act_num + 1, 1];
    }
    var getPersonLabel = function (speaker) {
        var regexp = new RegExp("^".concat(speaker, ", (.*)"));
        return props.play.dramatis_personae.reduce(function (prev, curr) {
            return prev || (regexp.test(curr) && regexp.exec(curr)[1]);
        }, null);
    };
    return (React.createElement("div", null,
        React.createElement(Header_1["default"], { curr_act: curr_act_num, curr_scene: curr_scene_num, play_id: props.play_id, title: props.play.title, prev_scene: prev_scene, next_scene: next_scene }),
        React.createElement(Scene_1["default"], { getPersonLabel: getPersonLabel, ident: "".concat(curr_act_num, ".").concat(curr_scene_num), scene: curr_scene })));
};
var Play = function () {
    var params = (0, react_router_dom_1.useParams)();
    var _a = React.useState(null), play = _a[0], setPlay = _a[1];
    if (!params.play_id) {
        throw new Error("no play specified");
    }
    console.log("Play() ".concat(params.play_id));
    if (!play) {
        fetch("/".concat(params.play_id, ".json"))
            .then(function (response) { return response.json(); })
            .then(function (play_data) {
            setPlay(play_data);
        })["catch"](function (error) {
            console.error(error);
        });
    }
    return (React.createElement(react_router_dom_1.Routes, null,
        React.createElement(react_router_dom_1.Route, { path: "/:act/:scene", element: React.createElement(React.Fragment, null,
                !play && React.createElement(Waiting, null),
                play && React.createElement(LoadedPlay, { play: play, play_id: params.play_id })) }),
        React.createElement(react_router_dom_1.Route, { path: "*", element: React.createElement(React.Fragment, null,
                !play && React.createElement(Waiting, null),
                play && React.createElement(PlaySummary_1["default"], { play: play, play_id: params.play_id })) })));
};
exports["default"] = Play;
